import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getSpeedTestQuestions, getSpeedTestSeriesQuestions, postFinalSubmitTest, postResumeTest, postSpeedTestQuestion, postSpeedTestSeriesQuestion, postSpeedTestSeriesSubmitQuestion, postSpeedTestSubmitQuestion, postTimerTest } from "../../MockTest/services/MockTest.service";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { AppRouteURL, TestSereisRouteURL } from "@Constants/app-route-url.constant";
import { MyTimer } from "@Components/CountDown/CountDown";
import { getUserDeviceDetails } from "@Src/utils/service/device-details.service";
import { CountDownActions, StopWatchActions } from '@Constants/app.constant';
import { TestTypes } from '@Constants/app.constant';
import { StopWatch } from "@Components/StopWatch/StopWatch";
import { QuestionCardIndex } from "@Src/features/MockTest/Components/Test-question-card/Question-card";
import { InstructionSetIndex } from "@Src/features/MockTest/Components/InstructionSet/InstructionSet";
import { QuestionPaletteIndex } from "@Src/features/MockTest/Components/Test-question-card/Question-palette";
import { QuestionPaperFooter } from "@Src/features/MockTest/Components/QuestionPaperFooter/QuestionPaperFooter";
import { EndTestDialog } from "@Components/EndTestDialog/EndTestDialog";
import { ExpireTimeEndTestDialog } from "@Components/ExpireTimeEndTestDialog/ExpireTimeEndTestDialog";
import { useAppDispatch, useAppSelector } from "@Src/app/hooks";
import { QuestionpaperrightFooter } from "@Src/features/MockTest/Components/QuestionPaperFooter/Questionpaperrightfooter";
import TimerSvg from "@Assets/svg/MockTest-svgs/Timer.svg"
import { showSpinner } from "@Src/app/reducers/globalSlice";
import { QuestionsExhaustDialog } from "@Components/QuestionsExhaustDialog/QuestionsExhaustDialog";
import { QuestionsNotAvailableDialog } from "@Components/QuestionsNotAvailableDialog/QuestionsNotAvailableDialog";
import { ClockTimer } from '@Src/features/MockTest/Components/Test-question-card/ClockTimer';


export const SpeedTestCard = ({ testId, noOfQuestion, timeDuration, isTestSeries, testIds, testName, generalInstruction }: any) => {
    const examType2 = window.location.pathname.includes(TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES);
    const examType1 = window.location.pathname.includes(TestSereisRouteURL.FULL_MOCK_SPEED_TEST_SERIES);
    const examType4 = window.location.pathname.includes(TestSereisRouteURL.PREVIOUS_YEAR_MOCK_SPEED_TEST_SERIES);

    const navigation = useNavigate();
    const testType = TestTypes.speed;
    const [instruction, setinstruction] = useState(false);
    const [Pauesedialog, setPauesedialog] = useState(false);
    const [questionsStore, setAllQuestions] = useState<any[]>([]);
    const [index, setIndex] = useState(0);
    const [endTestDialog, setEndTestDialog] = useState(false);
    const [action, setAction] = useState('');
    const [expireTestDialog, setExpireTestDialog] = useState(false);
    const [Qustpalette, setQustpalette] = useState(false);
    const isPaletteMobileViewport = getUserDeviceDetails().isMobileDevice && typeof window !== 'undefined' && window.innerWidth < 768;
    const [indexInNeed, setIndexInNeed] = useState(0);
    const userID = useAppSelector(state => state.login.userID)
    const fullQuestionPaperMode: boolean = false;
    const time = new Date();
    time.setSeconds(time.getSeconds() + (timeDuration * 60));
    const [submitAnswer, setSubmitAnswer] = useState<any>({});
    const params = useParams()
    const timer: any = useRef();
    const dispatch = useAppDispatch();
    const [questionsExhaustDialog, setQuestionsExhaustDialog] = useState<boolean>(false);
    const [questionsNotAvailbleDialog, setQuestionsNotAvailbleDialog] = useState<boolean>(false);
    const [pendingAnswers, setPendingAnswers] = useState<any[]>([]);
    const [timerKey, setTimerKey] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [timerExpiry, setTimerExpiry] = useState<Date>(() => {
        const t = new Date();
        t.setSeconds(t.getSeconds() + (timeDuration * 60));
        return t;
    });
    const ref: any = useRef();
    const [hasSelectedOption, setHasSelectedOption] = useState(false);

    useEffect(() => {
        const selected = submitAnswer?.SelectedOption;
        setHasSelectedOption(!!(selected && selected !== '' && selected !== 'null'));
    }, [submitAnswer, indexInNeed]);

    useEffect(() => {
        setIsLoading(true);
        if (isTestSeries) {
            insertSpeedTestSeriesQuestions()
        } else {
            insertSpeedTestQuestions()
        }
    }, []);

    useEffect(() => {
        const userTestId = questionsStore[0]?.UserTestId;
        const isPaused = action === CountDownActions.PAUSE;
        let stopped = false;

        if (isLoading || !userTestId) {
            if (timer.current) {
                clearInterval(timer.current);
                timer.current = null;
            }
            return;
        }

        if (isPaused) {
            if (timer.current) {
                clearInterval(timer.current);
                timer.current = null;
            }
            return;
        }

        if (action === CountDownActions.RESUME) {
            postTimerTest({ userTestId, timeTake: 0 });
            if (timer.current) {
                clearTimeout(timer.current);
            }
            let nextEventAt = Date.now() + 15000;
            const scheduleTimeEvent = () => {
                timer.current = setTimeout(async () => {
                    if (stopped) return;

                    const eventsDue = Math.max(1, Math.floor((Date.now() - nextEventAt) / 15000) + 1);
                    nextEventAt += eventsDue * 15000;

                    for (let eventIndex = 0; eventIndex < eventsDue && !stopped; eventIndex += 1) {
                        try {
                            await postTimerTest({ userTestId, timeTake: 15 });
                        } catch {
                        }
                    }

                    if (!stopped) {
                        scheduleTimeEvent();
                    }
                }, Math.max(0, nextEventAt - Date.now()));
            };
            scheduleTimeEvent();
        }

        return () => {
            stopped = true;
            if (timer.current) {
                clearTimeout(timer.current);
                timer.current = null;
            }
        };
    }, [action === CountDownActions.PAUSE, isLoading, questionsStore[0]?.UserTestId]);

    useEffect(() => {
        return () => {
            if (timer.current) {
                clearInterval(timer.current);
                timer.current = null;
            }
        };
    }, []);
    const speedTestQuestionSubmit = (params: any) => {
        dispatch(showSpinner(true));
        postSpeedTestSubmitQuestion(params).then((response: APIResponse) => {
            dispatch(showSpinner(false));
            if (response?.ResponseType == APIStatus.SUCCESS) {
                // clear pevious answer
                setSubmitAnswer({})
                let data = response.data[0];
                let previousQuestionAnswer = data.previousQueFlag;

                if (questionsStore[index].QuestionTypeId === 2) {
                    const selected = submitAnswer['SelectedOption'] ? submitAnswer['SelectedOption'].trim().split(',').map((s: string) => s.trim().toLowerCase()).filter((s: string) => s !== 'null' && s !== '') : [];
                    const actualAnsStr = data.previousQuestionCorrectAnswer || data.Ans || questionsStore[index].previousQuestionCorrectAnswer || questionsStore[index].Ans;
                    const actualAns = actualAnsStr ? actualAnsStr.trim().split(',').map((s: string) => s.trim().toLowerCase()).filter((s: string) => s !== 'null' && s !== '') : [];

                    if (selected.length > 0) {
                        const hasIncorrect = selected.some((opt: string) => !actualAns.includes(opt));
                        if (!hasIncorrect) {
                            previousQuestionAnswer = true;
                        } else {
                            previousQuestionAnswer = false;
                        }
                    } else {
                        previousQuestionAnswer = false;
                    }
                }

                let store = questionsStore;
                questionsStore[index]['IsVisited'] = true;
                questionsStore[index]['SelectedOption'] = submitAnswer['SelectedOption'];
                store[index]['previousQuestionAnswer'] = previousQuestionAnswer;
                delete data.previousQueFlag;
                let appendedQuestions = [...store, data];
                setAllQuestions(appendedQuestions);
                setIndex(index + 1);
                setAction('')
            } else if (response?.StatusMsg == "Question not found in speed test.") {
                questionsExhaustEventHandler();
            }
        }).catch((error) => {
            dispatch(showSpinner(false));
            console.log(error);

        })
    }

    const speedTestSeriesQuestionSubmit = (params: any) => {
        dispatch(showSpinner(true));
        postSpeedTestSeriesSubmitQuestion(params).then((response: APIResponse) => {
            dispatch(showSpinner(false));
            if (response?.ResponseType == APIStatus.SUCCESS) {
                // clear pevious answer
                setSubmitAnswer({})
                let data = response.data[0];
                let previousQuestionAnswer = data.previousQueFlag;

                if (questionsStore[index].QuestionTypeId === 2) {
                    const selected = submitAnswer['SelectedOption'] ? submitAnswer['SelectedOption'].trim().split(',').map((s: string) => s.trim().toLowerCase()).filter((s: string) => s !== 'null' && s !== '') : [];
                    const actualAnsStr = data.previousQuestionCorrectAnswer || data.Ans || questionsStore[index].previousQuestionCorrectAnswer || questionsStore[index].Ans;
                    const actualAns = actualAnsStr ? actualAnsStr.trim().split(',').map((s: string) => s.trim().toLowerCase()).filter((s: string) => s !== 'null' && s !== '') : [];

                    if (selected.length > 0) {
                        const hasIncorrect = selected.some((opt: string) => !actualAns.includes(opt));
                        if (!hasIncorrect) {
                            previousQuestionAnswer = true;
                        } else {
                            previousQuestionAnswer = false;
                        }
                    } else {
                        previousQuestionAnswer = false;
                    }
                }



                let store = questionsStore;
                questionsStore[index]['IsVisited'] = true;
                questionsStore[index]['SelectedOption'] = submitAnswer['SelectedOption'];
                store[index]['previousQuestionAnswer'] = previousQuestionAnswer;
                delete data.previousQueFlag;
                let appendedQuestions = [...store, data];
                setAllQuestions(appendedQuestions);
                setIndex(index + 1);
                setAction('')
            } else if (response?.StatusMsg == "Question not found in speed test.") {
                questionsExhaustEventHandler();
            }
        }).catch((error) => {
            dispatch(showSpinner(false));
            console.log(error);

        })

    }

    const insertSpeedTestQuestions = () => {
        let params = {
            "testId": testId,
            "duration": timeDuration * 60,
            "noOfQuestion": 1
        }
        postSpeedTestQuestion(params).then((response: APIResponse) => {
            if (response?.ResponseType == APIStatus.SUCCESS) {
                if (response?.StatusMsg === "User Question Already Inserted." && response?.data?.length > 0) {
                    const existingAnswers = response.data;
                    setPendingAnswers(existingAnswers);
                    const totalUsedSeconds = existingAnswers.reduce((sum: number, q: any) => sum + (q.TimeSpend || 0), 0);
                    const remainingSeconds = Math.max((timeDuration * 60) - totalUsedSeconds, 0);
                    const newExpiry = new Date();
                    newExpiry.setSeconds(newExpiry.getSeconds() + remainingSeconds);
                    setTimerExpiry(newExpiry);
                    setTimerKey(prev => prev + 1);
                }
                getSpeedTestQuestion();
            }
        })
    }


    const getSpeedTestQuestion = () => {
        let params = {
            "testId": testId,
            "difficultyLevel": 1
        }
        getSpeedTestQuestions(params).then((response: APIResponse) => {
            if (response?.ResponseType == APIStatus.SUCCESS) {
                const data = response.data || [];
                if (!data.length) {
                    setAllQuestions([]);
                    setIsLoading(false);
                    setQuestionsNotAvailbleDialog(true);
                    setAction(CountDownActions.PAUSE);
                    return;
                }

                setAllQuestions(data);
                setIsLoading(false);
                setAction(CountDownActions.RESUME);
            } else {
                questionsNotAvailableHandler();
            }
        })
    }

    const insertSpeedTestSeriesQuestions = () => {
        let params: any = {
            "examId": testId,
            "duration": timeDuration * 60,
            "noOfQuestion": 1
        }
        if (examType2) {
            params.examType = 2;
        } else if (examType1) {
            params.examType = 1;
        } else if (examType4) {
            params.examType = 3;
        } else {
            params.examType = 0;
        }
        postSpeedTestSeriesQuestion(params).then((response: APIResponse) => {
            if (response?.ResponseType == APIStatus.SUCCESS) {
                if (response?.StatusMsg === "User Question Already Inserted." && response?.data?.length > 0) {
                    const existingAnswers = response.data;
                    setPendingAnswers(existingAnswers);
                    const totalUsedSeconds = existingAnswers.reduce((sum: number, q: any) => sum + (q.TimeSpend || 0), 0);
                    const remainingSeconds = Math.max((timeDuration * 60) - totalUsedSeconds, 0);
                    const newExpiry = new Date();
                    newExpiry.setSeconds(newExpiry.getSeconds() + remainingSeconds);
                    setTimerExpiry(newExpiry);
                    setTimerKey(prev => prev + 1);
                }
                getSpeedTestSeriesQuestion();
            }
        })
    }


    const getSpeedTestSeriesQuestion = () => {
        let params = {
            "examId": testId,
            "difficultyLevel": 1
        }
        getSpeedTestSeriesQuestions(params).then((response: APIResponse) => {
            if (response?.ResponseType == APIStatus.SUCCESS) {
                const data = response.data || [];
                if (!data.length) {
                    setAllQuestions([]);
                    setIsLoading(false);
                    setQuestionsNotAvailbleDialog(true);
                    setAction(CountDownActions.PAUSE);
                    return;
                }

                setAllQuestions(data);
                setIsLoading(false);
                setAction(CountDownActions.RESUME);
            } else {
                questionsNotAvailableHandler();
            }
        })
    }


    const onClickSubmitionHandler = (params: any) => {
        setSubmitAnswer(params);
    }

    const onClickNextQuestion = () => {
        setIndexInNeed(index);
        postSpeedTestSubmitAnswer(submitAnswer)
    }

    const askNextSpeedTestQuestionHandler = (index: number) => {
    }

    const postSpeedTestSubmitAnswer = (params: any) => {
        params['timeSpend'] = ref.current.getStopWatchTimeHandler();
        if (isTestSeries) {
            speedTestSeriesQuestionSubmit(params)
        } else {
            speedTestQuestionSubmit(params)
        }
    }
    const onClickEndTest = () => {
        setEndTestDialog(true);
    }

    const endTest = () => {
        if (timer.current) {
            clearInterval(timer.current);
            timer.current = null;
        }
        setEndTestDialog(false);
        setExpireTestDialog(false);
        setQuestionsExhaustDialog(false);
        setQuestionsNotAvailbleDialog(false);
        let params = {
            "userTestId": questionsStore[0]['UserTestId'],
        }
        postFinalSubmitTest(params).then((response: APIResponse) => {
            if (response?.ResponseType == APIStatus.SUCCESS) {
                // const diagParam = examType ? '&examType=2' : '';
                if (isTestSeries) {
                    // navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.TESTRESULT}/${userID}?examId=${testId}&testType=2&userTestId=${questionsStore[0]['UserTestId']}${diagParam}`)
                    navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.TESTRESULT}/${userID}`, { state: { examId: testId, testType: 2, userTestId: questionsStore[0]['UserTestId'], examType: examType2 ? '2' : (examType1 ? '1' : (examType4 ? '3' : '')) } })
                } else {
                    // navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.TESTRESULT}/${userID}?testId=${testId}&testType=2&userTestId=${questionsStore[0]['UserTestId']}${diagParam}`)
                    navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.TESTRESULT}/${userID}`, { state: { testId: testId, testType: 2, userTestId: questionsStore[0]['UserTestId'], examType: examType2 ? '2' : (examType1 ? '1' : (examType4 ? '3' : '')) } })
                }
            }
        })
        // if (lastquestionSubmitFlag) {
        //     onClickNextQuestion();
        // }

    }

    const resumeTest = () => {
        setPauesedialog(false);
        setEndTestDialog(false);
        setQuestionsExhaustDialog(false);
        setQuestionsNotAvailbleDialog(false);
        setAction(CountDownActions.RESUME);
        let params = {
            "userTestId": questionsStore[0]['UserTestId'],
        }
        postResumeTest(params).then((response: APIResponse) => {
            if (response?.ResponseType == APIStatus.SUCCESS) {
            }
        })
    }

    const runningEventHandler = (isRunning: boolean) => {
        //  no action here to be taken
    }

    const expireEventHandler = () => {
        // as using worrker timeres, so mention window for default set time out
        window.setTimeout(() => {
            setExpireTestDialog(true);
            setAction(CountDownActions.PAUSE);
        }
            , 1000)
    }

    const jumpToQuestionHandler = (index: number) => {
        //  no action here to be taken
    }


    const updateTestQuestionHandler = (params: any) => {
        questionsStore[index]['SelectedOption'] = params['SelectedOption'];
    }

    const getStopWatchSpendTime = () => {
        //  setAction(StopWatchActions.RESET)
    }

    const resumeTestHandler = () => {
        resumeTest()
    }

    const setEndTestDialogHandler = (value: boolean) => {
        setEndTestDialog(value)
    }

    const endTestHandler = () => {
        endTest()
    }



    const onClickPreiousQuestionHandler = () => {
        // no need to write code here
    }

    const setQuestionpaletteHandler = () => {
        setQustpalette(!Qustpalette)
    }

    const onClickNextQuestionHandler = () => {
        onClickNextQuestion();
    }

    const setFullQuestionPaperModeHandler = (value: boolean) => {
        // no need to write code here
    }

    const setinstructionHadndler = (value: boolean) => {
        setinstruction(value)
    }

    const onClickEndTestHandler = () => {
        let params = submitAnswer;
        params['IsFinalSubmit'] = true;
        postSpeedTestSubmitAnswer(params)
        onClickEndTest()
    }

    const onActionChange = (time: number) => {
        // setSpendTime(time)
    }

    const questionsExhaustEventHandler = () => {
        setQuestionsExhaustDialog(true);
        setAction(CountDownActions.PAUSE);
        // setLastQuestionSubmitFlag(false);
    }

    const questionsNotAvailableHandler = () => {
        setQuestionsNotAvailbleDialog(true);
        setAction(CountDownActions.PAUSE);
        setIsLoading(false);
    }

    const endTestHandlerWithoutResult = () => {
        setEndTestDialog(false);
        setExpireTestDialog(false);
        setQuestionsExhaustDialog(false);
        setQuestionsNotAvailbleDialog(false);
        navigation('/')
    }

    const onClickBackButtonHandler = (value: boolean) => {
        setQustpalette(value);
        // setFullQuestionPaperMode(false);
        setinstruction(false);
    }

    useEffect(() => {
        document.body.classList.add("tw-overflow-hidden");
        return () => document.body.classList.remove("tw-overflow-hidden");
    }, []);

    return (
        <>
            <div className="test-question-container">
                <div className="test-qust-cards-container">
                    <div className="test-qust-header">
                        <div className="left-qust-header">
                            <div className="t-qust-heading">{testName}</div>
                            <div className="tw-flex tw-items-center tw-gap-2">
                                {
                                    !(examType1 || examType4 || examType2) && <ClockTimer threshold={questionsStore[index]?.DifficultyLevelAvgTime} isRunning={action !== 'pause'} resetKey={indexInNeed} hasSelectedOption={hasSelectedOption} />
                                }

                                <div className="t-qust-timer">

                                    {/* <span>
                                        <img src={TimerSvg} className="timer-img" alt="timer-svg" />

                                    </span> */}
                                    <span className="timer-span"><span className="my-timer-section">Time Left:</span>
                                        <MyTimer key={timerKey} expiryTimestamp={timerExpiry} action={isLoading || (!(questionsStore.length > 0)) ? CountDownActions.PAUSE : action} runningEventHandler={runningEventHandler} expireEventHandler={expireEventHandler} />
                                    </span>
                                    <StopWatch action={action} onActionChange={onActionChange} askNextSpeedTestQuestionHandler={askNextSpeedTestQuestionHandler} indexInNeed={indexInNeed} ref={ref} />
                                </div>
                            </div>

                        </div>

                        <div className="quest-palette-header py-3">Question Palette</div>
                    </div>

                    <div className="qust-palette-container">
                        <div className="test-question-card">
                                {isLoading ? (
                                    <div className="qust-container tw-p-6">
                                        <div className="tw-animate-pulse">
                                            <div className="tw-flex tw-items-center tw-gap-3 tw-mb-6">
                                                <div className="tw-h-8 tw-w-8 tw-bg-gray-200 tw-rounded"></div>
                                                <div className="tw-h-8 tw-w-8 tw-bg-gray-200 tw-rounded"></div>
                                                <div className="tw-h-5 tw-w-40 tw-bg-gray-200 tw-rounded"></div>
                                                <div className="tw-h-7 tw-w-24 tw-bg-gray-200 tw-rounded-full"></div>
                                            </div>
                                            <div className="tw-space-y-3 tw-mb-8">
                                                <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-full"></div>
                                                <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-5/6"></div>
                                                <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-3/4"></div>
                                            </div>
                                            {[1, 2, 3, 4].map(i => (
                                                <div key={i} className="tw-flex tw-items-center tw-gap-3 tw-border tw-border-gray-200 tw-rounded-lg tw-p-4 tw-mb-3">
                                                    <div className="tw-h-6 tw-w-6 tw-bg-gray-200 tw-rounded-full tw-shrink-0"></div>
                                                    <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-24"></div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ) : questionsStore.length > 0 ? (
                                    <div className="qust-container">
                                        <QuestionCardIndex question={questionsStore[index]} index={index} total={questionsStore.length} testType={testType} testId={testId} onClickSubmitionHandler={onClickSubmitionHandler} updateTestQuestionHandler={updateTestQuestionHandler} isTestSeries={isTestSeries} pendingQuestionsCount={pendingAnswers.length} />
                                    </div>
                                ) : null}

                            <QuestionPaperFooter testType={testType} fullQuestionPaperMode={fullQuestionPaperMode} index={index} questionsStoreLength={questionsStore.length} instruction={instruction} Qustpalette={Qustpalette} onClickPreiousQuestionHandler={onClickPreiousQuestionHandler} setQuestionpaletteHandler={setQuestionpaletteHandler} onClickNextQuestionHandler={onClickNextQuestionHandler} setFullQuestionPaperModeHandler={setFullQuestionPaperModeHandler} setinstructionHadndler={setinstructionHadndler} onClickEndTestHandler={onClickEndTestHandler} submitAnswer={submitAnswer} isTestSeries={isTestSeries} currentQuestion={questionsStore[index]} isLoading={isLoading}/>


                        </div>

                        <div>
                            <div className={`qust-palette-card  ${(instruction || Qustpalette) ? 'qust-mob-card isactive-card' : ''}`}>
                                {instruction && (
                                    <InstructionSetIndex setinstructionValue={setinstruction} generalInstruction={generalInstruction} setQustpalette={setQustpalette}/>
                                )}


                {isLoading && !isPaletteMobileViewport && (
                  <div className="tw-animate-pulse" style={{ padding: '25px 32px' }}>
                    {/* "Question Number" heading */}
                    <div className="tw-h-5 tw-w-40 tw-bg-gray-200 tw-rounded tw-mb-5"></div>
                    {/* subject label */}
                    <div className="tw-h-3 tw-w-16 tw-bg-gray-200 tw-rounded tw-mb-3"></div>
                    {/* grid of number boxes matching 45x45 with margin 17px 20px */}
                    <div className="tw-flex tw-flex-wrap" style={{ margin: '0 -20px' }}>
                      {[...Array(20)].map((_, i) => (
                        <div
                          key={i}
                          className="tw-bg-gray-200 tw-rounded"
                          style={{ width: 45, height: 45, margin: '17px 20px', flexShrink: 0 }}
                        ></div>
                      ))}
                    </div>
                  </div>
                )}
                                {!isLoading && !isPaletteMobileViewport && !instruction && <QuestionPaletteIndex questions={questionsStore} jumpToQuestionHandler={jumpToQuestionHandler} testType={testType} activeIndex={index} pendingAnswers={pendingAnswers} onClickBackButtonHandler={onClickBackButtonHandler} fullQuestionPaperMode={fullQuestionPaperMode} />}
                                {!isLoading && isPaletteMobileViewport && Qustpalette && <QuestionPaletteIndex questions={questionsStore} jumpToQuestionHandler={jumpToQuestionHandler} testType={testType} setQustpalette={setQustpalette} onClickBackButtonHandler={onClickBackButtonHandler} fullQuestionPaperMode={fullQuestionPaperMode} activeIndex={index} pendingAnswers={pendingAnswers} />}

                            </div>
                            <div className="speed-test-right-footer">
                                <QuestionpaperrightFooter testType={testType} fullQuestionPaperMode={fullQuestionPaperMode} instruction={instruction} setFullQuestionPaperModeHandler={setFullQuestionPaperModeHandler} setinstructionHadndler={setinstructionHadndler} onClickEndTestHandler={onClickEndTestHandler} isLoading={isLoading}/>

                            </div>
                        </div>
                    </div>




                </div>
            </div>

            <EndTestDialog endTestDialog={endTestDialog} setEndTestDialogHandler={setEndTestDialogHandler} endTestHandler={endTestHandler} resumeTestHandler={resumeTestHandler} totalQuestions={noOfQuestion} answeredQuestions={questionsStore.filter((q: any) => q.SelectedOption !== null && q.SelectedOption !== undefined && q.SelectedOption !== "").length} testType={testType} />

            <ExpireTimeEndTestDialog expireTestDialog={expireTestDialog} endTestHandler={endTestHandler} />
            <QuestionsExhaustDialog questionsExhaustDialog={questionsExhaustDialog} endTestHandler={endTestHandler} />
            <QuestionsNotAvailableDialog questionsNotAvailbleDialog={questionsNotAvailbleDialog} endTestHandlerWithoutResult={endTestHandlerWithoutResult} />
        </>
    );
};
